import { render, staticRenderFns } from "./PorPlazas.vue?vue&type=template&id=4512f4c9"
import script from "./PorPlazas.vue?vue&type=script&lang=js"
export * from "./PorPlazas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports